import { queueActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  error: '',
  queueMessages: {
    message: '',
    data: {},
  },
};

const queueReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.FETCH_QUEUE_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        queueMessages: {
          message: '',
          data: {},
        },
      };
    case ACTION.FETCH_QUEUE_SUCCESS:
      let { message, payload } = action.payload;
      return {
        ...state,
        loading: false,
        error: '',
        queueMessages: {
          message: message,
          data: payload,
        },
      };
    case ACTION.FETCH_QUEUE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        queueMessages: {
          message: '',
        },
      };
    default:
      return state;
  }
};
export default queueReducer;
